<template>
  <div>
    <div class="signPage">
      <div class="signTitle">
        <van-icon name="arrow-left" @click="$router.go(-1)"/>
        <p>签名</p>
      </div>
      <Signature_pad :config="{
    penColor: 'black',
    minWidth:2
  }" @receive="receiveQmValue"></Signature_pad>
    </div>

  </div>
</template>

<script>
import Signature_pad from "@/components/signature_pad";

export default {
  name: "signPage",
  components: {
    Signature_pad
  },
  mounted() {
    window.addEventListener("resize", this.renderResize, false)
  },
  destroyed() {
    window.removeEventListener("resize", this.renderResize,)
  },
  methods: {
    renderResize() {
      // 判断横竖屏
      let width = document.documentElement.clientWidth
      let height = document.documentElement.clientHeight
      if (width > height) {
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          message: '请开启设备竖排方向锁定后在尝试！'
        });
      }
    },
    receiveQmValue(val) {
      localStorage.setItem('signObj', null)
      localStorage.setItem('signObj', JSON.stringify(val))
      this.$router.push({
        path: 'print/paymentSlip',
        query: {
          noticeNo: this.$route.query.noticeNo
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.signPage {
  min-height: 100vh;
  background-image: url("../../assets/img/backLogin.png");
  background-size: 100% 100%;

  .signTitle {
    height: 46px;
    display: flex;
    align-items: center;
    color: #fff;
    position: relative;
    justify-content: center;

    i {
      position: absolute;
      left: 10px;
      font-size: 17px;
    }

    p {
      font-size: 17px;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 600;
    }

  }
}
</style>
